import { Record } from "immutable";

interface IPolicyConflictRole {
  bundleName?: string;
  roleId: string;
  roleName?: string;
}

interface IRoleDuplication {
  ignoredRoles: IPolicyConflictRole[];
  integrationName: string;
  resourceName: string;
  takenRole: IPolicyConflictRole;
}

const defaults = {
  actorlessRoles: [] as IPolicyConflictRole[],
  roleDuplications: {} as { [key: string]: IRoleDuplication },
};

export class PolicyConflictsModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const parsedData = data as typeof defaults;

    return new PolicyConflictsModel(parsedData);
  }
}
